import { render, staticRenderFns } from "./CreateCanvas.vue?vue&type=template&id=80244816&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports